import { render } from "./ConsorcioPage.vue?vue&type=template&id=b8f2019e&scoped=true"
import script from "./ConsorcioPage.vue?vue&type=script&lang=js"
export * from "./ConsorcioPage.vue?vue&type=script&lang=js"

import "./ConsorcioPage.vue?vue&type=style&index=0&id=b8f2019e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f2019e"]])

export default __exports__